"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { ExternalStoryCtaConfig } from "@/lib/external-story-cta";
interface ExternalStoryCtaPromptProps {
  cta: ExternalStoryCtaConfig;
}
export function ExternalStoryCtaPrompt(t0) {
  const $ = _c(23);
  const {
    cta
  } = t0;
  const sentinelRef = useRef(null);
  const hasOpenedRef = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  let t1;
  let t2;
  if ($[0] !== hasOpened) {
    t1 = () => {
      const sentinel = sentinelRef.current;
      if (!sentinel || hasOpened) {
        return;
      }
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (!entry.isIntersecting || hasOpenedRef.current) {
          return;
        }
        hasOpenedRef.current = true;
        setHasOpened(true);
        setIsOpen(true);
      }, {
        threshold: 0.75
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t2 = [hasOpened];
    $[0] = hasOpened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== cta.url) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /^www\./;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = new URL(cta.url).hostname.replace(t4, "");
    $[3] = cta.url;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const destinationHost = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div ref={sentinelRef} className="h-px" data-testid="external-story-cta-sentinel" aria-hidden="true" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogTitle className="font-heading text-2xl">The story continues…</DialogTitle>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== cta.message) {
    t6 = <DialogHeader className="text-center sm:text-center">{t5}<DialogDescription className="whitespace-pre-wrap pt-2 text-base">{cta.message}</DialogDescription></DialogHeader>;
    $[8] = cta.message;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ExternalLink className="size-4" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== cta.buttonLabel || $[12] !== cta.url) {
    t8 = <Button asChild={true} size="lg" className="mt-2 w-full"><a href={cta.url} target="_blank" rel="noopener noreferrer nofollow">{cta.buttonLabel}{t7}</a></Button>;
    $[11] = cta.buttonLabel;
    $[12] = cta.url;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== destinationHost) {
    t9 = <p className="text-center text-xs text-muted-foreground">Opens {destinationHost} in a new tab</p>;
    $[14] = destinationHost;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t8 || $[18] !== t9) {
    t10 = <DialogContent className="sm:max-w-md">{t6}{t8}{t9}</DialogContent>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isOpen || $[21] !== t10) {
    t11 = <>{t4}<Dialog open={isOpen} onOpenChange={setIsOpen}>{t10}</Dialog></>;
    $[20] = isOpen;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}